export const GET_REFERENCE_DATA_REQUEST = 'GET_REFERENCE_DATA_REQUEST';
export const GET_REFERENCE_DATA_SUCCESS = 'GET_REFERENCE_DATA_SUCCESS';
export const GET_REFERENCE_DATA_FAILURE = 'GET_REFERENCE_DATA_FAILURE';

export const CLEAR_REFERENCE_DATA = 'CLEAR_REFERENCE_DATA';

